import { Typography } from "@mui/material";
import AdministracionRutas from "components-base/pages/administracionrutas"
const Rutas = () =>{

    return(
        <div className="flex w-full flex-col gap-5"><AdministracionRutas /></div>
    )
}
export default Rutas;